module.exports = __webpack_public_path__ + "static/media/Music for the Soul - Instrumental Version.97730967.jpg";